// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"TreatmentOrder__Wrapper_2kJQ2","Title":"TreatmentOrder__Title_2QuKN","Download":"TreatmentOrder__Download_2rlxT","Button":"TreatmentOrder__Button_4HQbS"};